import { tr } from "./language";
const EMAIL_RE =
  /(^|[^\w.!#$%&'*+/=?^`{|}~-])([A-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+)+)(?=$|[^\w-])/i;
const PHONE_CANDIDATE_RE = /(?:\+?\d[\d\s().-]{4,}\d)/g;
const WEBSITE_RE =
  /(?:https?:\/\/|www\.)\S+|(?:^|[^\w@])(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}(?::\d{2,5})?(?:[/?#][^\s]*)?(?=$|[^\w])/i;

export const containsEmailAddress = (value = "") => EMAIL_RE.test(String(value));

export const containsPhoneNumber = (value = "") => {
  const matches = String(value).match(PHONE_CANDIDATE_RE) || [];
  return matches.some((match) => {
    const digits = match.replace(/\D/g, "");
    return digits.length >= 6 && digits.length <= 15;
  });
};

export const containsWebsite = (value = "") => WEBSITE_RE.test(String(value));

export const shopTextError = (value = "") => {
  const text = String(value);
  if (containsEmailAddress(text)) return tr("Emails aren't allowed in this field.");
  if (containsPhoneNumber(text)) return tr("Phone numbers aren't allowed in this field.");
  if (containsWebsite(text)) return tr("Websites aren't allowed in this field.");
  return "";
};

export const getShopTextErrors = (tagline = "", bio = "") => ({
  tagline: shopTextError(tagline),
  bio: shopTextError(bio),
});
